<template>
  <div class="main">
    <b-modal
      id="modalview"
      title="View Details"
      cancel-variant="secondary"
      ok-title="Ok"
      cancel-title="Close"
      centered
      v-model="showViewModal"
    >
      <div v-if="selectedItem">
        <p><strong>Employee Name:</strong> {{ selectedItem.employeeName }}</p>
        <p><strong>Status:</strong> {{ selectedItem.status }}</p>
        <p>
          <strong>Allocation Type:</strong> {{ selectedItem.allocationType }}
        </p>
        <p><strong>Category:</strong> {{ selectedItem.category }}</p>
        <p><strong>Amount:</strong> Rs {{ selectedItem.amount }}</p>
        <p><strong>Notes:</strong> {{ selectedItem.notes }}</p>
        <p>
          <strong>Is Recurring:</strong>
          {{ selectedItem.isRecurring == true ? "Yes" : "No" }}
        </p>
        <p>
          <strong>Allocation Date:</strong>
          {{ formatDate(selectedItem.allocationDate) }}
        </p>
      </div>
      <template #modal-footer cancel-title="Close"></template>
    </b-modal>

    <b-modal
      id="editModal"
      title="Edit Allocation"
      v-model="showEditModal"
      centered
      hide-footer
    >
      <b-form @submit.prevent="editAllocation">
        <b-row>
          <b-col md="12">
            <b-form-group label="Employee Name" label-for="employeeNameInput">
              <b-form-input
                v-model="selectedItem.employeeName"
                readonly
                label="title"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Status" label-for="status">
              <b-form-select
                id="status"
                v-model="selectedItem.status"
                :options="statusOptions"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Allocation Type"
              label-for="allocationTypeInput"
            >
              <b-form-select
                id="allocationTypeInput"
                v-model="selectedItem.allocationType"
                :options="typeOptions"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Category" label-for="categoryInput">
              <b-form-select
                id="category"
                v-model="selectedItem.category"
                :options="categoryOptions"
                required
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Amount" label-for="amount">
              <b-form-input
                id="amount"
                v-model="selectedItem.amount"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Notes" label-for="notes">
              <b-form-input
                id="notes"
                v-model="selectedItem.notes"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Replace the b-form-input with b-form-select for allocationDate -->
        <b-row>
          <b-col md="12">
            <b-form-group label="Allocation Date" label-for="allocationDate">
              <b-form-select
                id="allocationDate"
                :value="formatDate(selectedItem.allocationDate)"
                :options="last12Months"
                required
                @change="onDateChange"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label-for="isRecurring">
              <b-form-checkbox
                id="isRecurring"
                v-model="selectedItem.isRecurring"
              >
                Is Recurring?
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            block
            :disabled="invalid"
            @click="editAllocation()"
          >
            <b-spinner small v-if="loading" class="mx-2" />Update
          </button>
          <button
            type="button"
            class="btn btn-danger"
            block
            :disabled="invalid"
            @click="closeEditModal"
          >
            Cancel
          </button>
        </div>
      </b-form>
    </b-modal>

    <b-card>
      <b-card-body>
        <b-row>
          <b-col md="12" class="d-flex justify-content-end">
            <b-button variant="primary" v-b-modal.addModal class="my-1 mr-2">
              Import Allocation
            </b-button>

            <b-button
              v-if="HasPermission(PermissionList.HRMS_Create)"
              variant="primary"
              class="my-1 mr-2"
              :to="{
                path: '/hrmanagement/Allocations/AddAllocation/add-allocation',
              }"
            >
              <feather-icon icon="PlusIcon" />
              Add Allocation
            </b-button>
            <!-- <b-button
             v-if="HasPermission(PermissionList.HRMS_Create)"
              variant="primary"
              :to="{ path: '/hrmanagement/Allocations/AddAllocation/add-allocation' }"
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add Allocation
            </b-button> -->
          </b-col>
        </b-row>

        <b-modal
          id="addModal"
          title="Import Allocation"
          v-model="showAddModal"
          cancel-title="Close"
          hide-footer
          centered
        >
          <b-form @submit.prevent="ImportAllocation">
            <b-row>
              <div class="m-4">
                <b-form-group label="Upload File" label-for="file-input ">
                  <b-form-file
                    id="file-input"
                    v-model="file"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </b-form-group>

                <!-- Display Selected File -->
                <b-card-text class="my-1">
                  Selected file:
                  <strong>{{ file ? file.name : "No file selected" }}</strong>
                </b-card-text>
              </div>
              <!-- File Input -->
            </b-row>

            <div class="d-flex justify-content-end">
              <b-button variant="secondary" @click="closemodal()" class="mr-2"
                >Cancel</b-button
              >
              <b-button
                type="button"
                @click="ImportAllocation()"
                variant="primary"
                >Submit</b-button
              >
            </div>
          </b-form>
        </b-modal>
        <b-row>
          <b-col cols="12" md="2" sm="9 " class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            class="d-flex justify-content-end mb-2"
            style="position: relative; z-index: 1"
          >
            <b-button
              v-if="HasPermission(PermissionList.HRMS_Search)"
              variant="outline-danger"
              @click="clearFilters"
            >
              Clear Filters
            </b-button>
          </b-col>
        </b-row>

        <!-- this is a test -->

        <b-row>
          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :fields="fields"
              :items="filteredAllocations"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
            >
              <!-- Filter inputs for columns -->
              <template #head(employeeName)="scope">
                <div class="d-flex flex-column">
                  <span
                    @click="toggleSort('employeeName')"
                    style="cursor: pointer"
                    >Employee Name</span
                  >
                  <b-form-input
                    v-model="filters.employeeName"
                    placeholder="Filter by Employee Name"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(status)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('status')" style="cursor: pointer"
                    >Status</span
                  >
                  <b-form-input
                    v-model="filters.status"
                    placeholder="Filter by Status"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(allocationType)="scope">
                <div class="d-flex flex-column">
                  <span
                    @click="toggleSort('allocationType')"
                    style="cursor: pointer"
                    >Allocation Type</span
                  >
                  <b-form-input
                    v-model="filters.allocationType"
                    placeholder="Filter by Allocation Type"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(allocationDate)="scope">
                <div class="d-flex flex-column">
                  <span
                    @click="toggleSort('allocationDate')"
                    style="cursor: pointer"
                    >Allocation Date</span
                  >
                  <b-form-input
                    v-model="filters.allocationDate"
                    placeholder="Filter by Allocation Date"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(amount)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('amount')" style="cursor: pointer"
                    >Amount</span
                  >
                  <b-form-input
                    v-model="filters.amount"
                    placeholder="Filter by Amount"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #head(notes)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('notes')" style="cursor: pointer"
                    >Notes</span
                  >
                  <b-form-input
                    v-model="filters.notes"
                    placeholder="Filter by Notes"
                    @input="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>

              <template #cell(employeeName)="data">
                {{ data.value }}
              </template>

              <template #cell(status)="data">
                {{ data.value }}
              </template>

              <template #cell(allocationType)="data">
                {{ data.value }}
              </template>
              <template #cell(allocationDate)="data">
                {{ formatDate(data.value) }}
              </template>

              <template #cell(isRecurring)="data">
                {{ data.value ? "Yes" : "No" }}
              </template>

              <template #cell(amount)="data">
                {{ data.value }}
              </template>

              <template #cell(notes)="data">
                {{ data.value }}
              </template>

              <template #cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item @click="viewDetails(data.item)">
                    <feather-icon icon="EyeIcon" class="mr-50" />
                    <span>View</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="openEditModal(data.item)">
                    <feather-icon icon="EditIcon" class="mr-50" />
                    <span>Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="removeAllocation(data.item.id)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <div class="d-flex justify-content-center mb-1">
              <b-spinner
                variant="success"
                label="Spinning"
                block
                v-if="loading"
                style="width: 3rem; height: 3rem"
              ></b-spinner>
            </div>
          </b-col>
          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
            <b-form-group>
              Showing
              {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
              to
              {{
                totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0
              }}
              of
              {{ totalRows > 0 ? totalRows : 0 }}
              entries
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormFile,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import moment from "moment";
export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormFile,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    BFormCheckbox,
  },
  data() {
    return {
      showSpinner: true,
      last12Months: [],
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      file: null,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      token: localStorage.getItem("accessToken"),
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      items: [],
      filters: {
        employeeName: "",
        status: "",
        allocationType: "",
        allocationDate: "",
        amount: "",
        notes: "",
      },
      fields: [
        { key: "employeeName", label: "Employee Name", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "allocationType", label: "Allocation Type", sortable: true },
        { key: "allocationDate", label: "Allocation Date", sortable: true },
        { key: "amount", label: "Amount", sortable: true },
        { key: "notes", label: "Notes", sortable: true },
        { key: "isRecurring", label: "Recurring?", sortable: true },

        { key: "actions", label: "Actions", sortable: true },
      ],
      showViewModal: false,
      showEditModal: false,
      showAddModal: false,
      selectedItem: {
        employeeName: "",
        status: "",
        allocationType: "",
        amount: 0,
        notes: "",
        allocationDate: "",
        category: "",
      },
      typeOptions: [
        { value: "Income", text: "Income" },
        { value: "Deduction", text: "Deduction" },
      ],
      statusOptions: [
        { value: "Pending", text: "Pending" },
        { value: "Approved", text: "Approved" },
        { value: "Declined", text: "Declined" },
        { value: "Cancelled", text: "Cancelled" },
      ],
      categoryOptions: [
        { value: "Basic", text: "Basic" },
        { value: "PAYE", text: "PAYE" },
        { value: "NSF", text: "NSF" },
        { value: "PRGF", text: "PRGF" },
        { value: "Insurance", text: "Insurance Deduction" },
        { value: "Loan", text: "Loan Deduction" },
        { value: "Bonus", text: "Bonus" },
        { value: "CSG", text: "CSG" },
        { value: "Overtime", text: "Overtime" },
        { value: "Travelling", text: "Travelling" },
      ],
      allocationDate: this.getLast12Months(),
      last12Months: this.getLast12Months(),
    };
  },
  computed: {
    ...mapGetters("allocationModule", {
      allocation: "allocation",
      loading: "loading",
    }),
    filteredAllocations() {
      return this.allocation.filter((item) => {
        return (
          (!this.filters.employeeName ||
            item.employeeName
              .toLowerCase()
              .includes(this.filters.employeeName.toLowerCase())) &&
          (!this.filters.status ||
            item.status
              .toLowerCase()
              .includes(this.filters.status.toLowerCase())) &&
          (!this.filters.allocationType ||
            item.allocationType
              .toLowerCase()
              .includes(this.filters.allocationType.toLowerCase())) &&
          (!this.filters.allocationDate ||
            this.formatDate(item.allocationDate)
              .toLowerCase()
              .includes(this.filters.allocationDate.toLowerCase())) &&
          (!this.filters.amount ||
            String(item.amount).includes(this.filters.amount)) &&
          (!this.filters.notes ||
            item.notes.toLowerCase().includes(this.filters.notes.toLowerCase()))
        );
      });
    },
  },
  created() {
    this.last12Months = this.getLast12Months(); // Populate the months when the component is created
  },
  methods: {
    ...mapActions("allocationModule", [
      "getAllocationListAction",
      "updateAllocationAction",
      "removeAllocationAction",
      "importAllocationAction",
    ]),

    getLast12Months() {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const today = new Date();
      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();
      let last12Months = [];

      for (let i = 0; i < 12; i++) {
        let month = (currentMonth - i + 12) % 12;
        let year = currentYear - Math.ceil((i - currentMonth) / 12);
        last12Months.push(`${months[month]} ${year}`);
      }

      console.log("return date", last12Months.reverse());
      return last12Months.reverse();
    },

    onDateChange(newValue) {
      // Convert the selected month-year back to the full date format

      let date = new Date("01 " + newValue);
      console.log("date", date);
      this.selectedItem.allocationDate = date;
    },

    // formatDate(date) {
    //   console.log("date", date)
    //   const options = { year: "numeric", month: "short", day: "numeric" };
    //   return new Date(date).toLocaleDateString("en-US", options);
    // },
    formatDate(date) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const d = new Date(date); // Convert ISO string to Date object
      const month = months[d.getMonth()];
      const year = d.getFullYear();
      return `${month} ${year}`;
    },
    formatAllDate(date) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const d = new Date(date); // Convert the input string into a Date object
      const month = d.getUTCMonth(); // Get the UTC month (so that it doesn't shift by time zone)
      const year = d.getUTCFullYear(); // Get the UTC year
      return new Date(Date.UTC(year, month, 40)); // Return the first day of the month in UTC
    },

    successAdd() {
      this.$swal({
        title: "Import Allocation!",
        text: "You have successfully Import Allocation!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    successEdit() {
      this.$swal({
        title: "Allocation edited!",
        text: "You have successfully edited an Allocation!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    errorEdit() {
      this.$swal({
        title: "Error!",
        text: "Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    viewDetails(allocation) {
      this.selectedItem = allocation;
      this.showViewModal = true;
    },
    openEditModal(allocation) {
      this.selectedItem = allocation;
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.getAllocationListAction().then(() => {
        this.totalRows = this.allocation.length;
      });
    },

    closemodal() {
      this.$bvModal.hide("addModal");
      this.showAddModal = false;
      this.getAllocationListAction().then(() => {
        this.totalRows = this.allocation.length;
      });
    },

    editAllocation() {
      console.log(
        "this.selectedItem.allocationDate",
        this.selectedItem.allocationDate
      );

      let payload = {
        id: this.selectedItem.id,
        employeeId: this.selectedItem.employeeId,
        status: this.selectedItem.status,
        allocationType: this.selectedItem.allocationType,
        amount: this.selectedItem.amount,
        notes: this.selectedItem.notes,
        category: this.selectedItem.category,
        // allocationDate: this.selectedItem.allocationDate
        // allocationDate: moment("01 " + this.selectedItem.allocationDate).format(
        //     "YYYY-MM-DD"
        //   ),
        allocationDate: moment(this.selectedItem.allocationDate).format(
          "YYYY-MM-DD"
        ),
        isRecurring: this.selectedItem.isRecurring,
      };
      console.log("payload", payload);
      this.updateAllocationAction(payload)
        .then(() => {
          this.successEdit();
          this.$bvModal.hide("editModal");
          this.getAllocationListAction();
          this.totalRows = this.allocation.length;
        })
        .catch(() => {
          this.errorEdit();
          this.$bvModal.hide("editModal");
          this.getAllocationListAction();
          this.totalRows = this.allocation.length;
        });
    },

    ImportAllocation() {
      let docForm = new FormData();

      docForm.append("File", this.file);

      this.importAllocationAction(docForm)
        .then(() => {
          this.successAdd();
          this.$bvModal.hide("addModal");
          this.showAddModal = false;
          this.getAllocationListAction().then((response) => {
            this.totalRows = this.allocation.length;
            console.log(response);
          });
          this.file = null;
        })
        .catch((error) => {
          console.log(error);
          // Extract the error message from the response
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "An unexpected error occurred.";

          this.$swal({
            icon: "error",
            title: "Error!",
            text: errorMessage, // Display the extracted error message
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.showAddModal = false;
          
          this.getAllocationListAction().then((response) => {
            this.totalRows = this.allocation.length;
            console.log(response);
          });
          //this.errorAdd();
        });
    },

    errorAdd() {
      this.$swal({
        title: "Error!",
        text: "Please check your import data and contact support!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    removeAllocation(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          console.log("remove");
          this.removeAllocationAction(id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Allocation has been deleted",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getAllocationListAction().then(() => {
                this.totalRows = this.allocation.length;
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error!",
                text: error.response.data.message,
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getAllocationListAction().then(() => {
                this.totalRows = this.allocation.length;
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Allocation not deleted",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    applyFilters() {
      this.currentPage = 1; // Reset to the first page when filters are applied
    },
    clearFilters() {
      // Reset all filter values to their default state
      this.filters = {
        employeeName: "",
        status: "",
        allocationType: "",
        allocationDate: "",
        amount: "",
        notes: "",
      };

      // Reset the current page and filtered items
      this.currentPage = 1;
    },

    getLast12Months() {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const today = new Date();
      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();
      let last12Months = [];

      for (let i = 0; i < 12; i++) {
        let month = (currentMonth - i + 12) % 12;
        let year = currentYear - Math.ceil((i - currentMonth) / 12);
        last12Months.push(`${months[month]} ${year}`);
      }

      return last12Months.reverse();
    },
  },
  mounted() {
    // this.selectedItem.allocationDate = this.getLast12Months()[0];
    // console.log("getaloocationate", this.selectedItem);
    this.getAllocationListAction()
      .then((response) => {
        this.totalRows = this.allocation.length;
        console.log(response);
      })
      .catch((response) => {
        console.log(response);
      });
    this.totalRows = this.allocation.length;
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },
};
</script>
